'use client';

import { useAppContext } from '@/context/app';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function NormalPageActiveColumn() {
  const [
    ,
    {
      actions: { setActiveColumn },
    },
  ] = useAppContext();
  const pathname = usePathname();

  useEffect(() => {
    setActiveColumn('home');
  }, [setActiveColumn, pathname]);

  return null;
}
